module.exports = "/fonts/ARIALLGT.woff?8d681b693868dc0ea7f90caf12e1a7c2";